import './Home.css';
import { Helmet } from "react-helmet";

import '../Assets/vendor/bootstrap/css/bootstrap.min.css';
import '../Assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../Assets/vendor/boxicons/css/boxicons.min.css';
import '../Assets/vendor/glightbox/css/glightbox.min.css';
import '../Assets/vendor/swiper/swiper-bundle.min.css';

import Header from './Header';
import Hero from './Hero';
import Main from './Main';
import Footer from './Footer';
import BackToTop from './BackToTop';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Devaprasad | Portfolio</title>
        <meta name="description" content="Portfolio of Devaprasad, a Software Developer specializing in React, Node.js, and Modern Web Technologies." />
        <meta name="keywords" content="Devaprasad, Portfolio, Web Developer, React Developer, Software Engineer" />
      </Helmet>
      <div className="home-page">
        <Header/>
        <Hero/>
        <Main/>
        <Footer/>
        <BackToTop/>
      </div>
    </>
  );
}

export default Home;